import { ColDef } from '@ag-grid-community/core';

import { formatEpochDate } from 'Lib/stringHelpers';

export const adminUsersColumnDefs: Array<ColDef> = [
    {
        field: '',
        headerName: 'Name',
        valueGetter: (params) => `${params.data.FirstName} ${params.data.LastName}`,
        menuTabs: ['filterMenuTab'],
        flex: 2
    },
    {
        field: 'UserRoleDisplay',
        headerName: 'Role',
        menuTabs: ['filterMenuTab'],
        flex: 2
    },
    {
        field: 'UpdatedAt',
        headerName: 'Last Modified',
        valueFormatter: (params) => formatEpochDate(params.data.UpdatedAt),
        menuTabs: ['filterMenuTab'],
        minWidth: 180,
        flex: 3
    },
    {
        //Status column will not have a header to hold Export button
        field: '',
        headerName: '',
        valueGetter: ({ data }) => data,
        cellRenderer: 'userStatusCellRenderer',
        menuTabs: [],
        minWidth: 60,
        maxWidth: 80,
        flex: 1
    }
];